import { provide } from 'vue';
import { d as dsSymbol } from './useFormKitSection-0P94qXKh.js';

function useFormKitComponent(context) {
  provide(dsSymbol, context);
}

export { useFormKitComponent as u };
//# sourceMappingURL=useFormKitComponent-3i_LcQ9S.js.map
